import styled from 'styled-components';

export const SectionHeader = styled.div`
    text-align: left;
    padding: 20px 24px 0px;
`;
